import { css } from "@emotion/css";
import { mergeProps } from "react-aria";
import { Radio as AriaRadio, RadioProps } from "react-aria-components";

import { getTextStyle } from "@certn/cascadia-react/foundations/typography/styles";

import { _RadioAsset } from "./_RadioAsset";
import { sharedStyles, useCardInputStyles } from "../../styles";

interface Props extends RadioProps {
  isCard?: boolean;
  strong?: boolean;
  helpText?: string;
}

export function _Radio(props: Props) {
  const cardStyles = useCardInputStyles();

  const {
    isCard,
    helpText,
    strong = helpText !== undefined || isCard,
    ...radioProps
  } = props;

  const className = css(
    styles.radio,
    strong && getTextStyle("input/label"),
    isCard && cardStyles,
    isCard && sharedStyles.basicCard
  );

  return (
    <AriaRadio {...mergeProps(radioProps, { className })}>
      {(renderProps) => {
        return (
          <>
            <_RadioAsset
              {...renderProps}
              isFocused={isCard ? false : renderProps.isFocused}
              isFocusVisible={isCard ? false : renderProps.isFocusVisible}
            />
            <div className={css(styles.text)}>
              {typeof props.children === "function"
                ? props.children(renderProps)
                : props.children}
            </div>
          </>
        );
      }}
    </AriaRadio>
  );
}

const styles = {
  radio: css(
    {
      cursor: "pointer",
      display: "flex",
      flexDirection: "row",
      gap: "var(--space-2)",
      paddingBottom: "var(--space-1)",
      paddingTop: "var(--space-1)",
    },
    getTextStyle("form/body-secondary")
  ),
  text: css({
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-1)",
  }),
};
